import { render, staticRenderFns } from "./TransactionConfirmationBC.vue?vue&type=template&id=1e826e48&scoped=true&"
import script from "./TransactionConfirmationBC.vue?vue&type=script&lang=js&"
export * from "./TransactionConfirmationBC.vue?vue&type=script&lang=js&"
import style0 from "./TransactionConfirmationBC.vue?vue&type=style&index=0&id=1e826e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e826e48",
  null
  
)

export default component.exports